import React from 'react';
import { cn } from '../lib/utils';
import { motion } from 'framer-motion';
interface ListicleSectionProps {
  number: number;
  headline: string;
  children: React.ReactNode;
  imageSrc?: string;
  imageAlt?: string;
  imageRight?: boolean;
  customVisual?: React.ReactNode;
}
export function ListicleSection({
  number,
  headline,
  children,
  imageSrc,
  imageAlt,
  imageRight = false,
  customVisual
}: ListicleSectionProps) {
  return <section className="max-w-5xl mx-auto px-4 py-12 sm:py-16" data-id="element-33">
      <div className={cn('flex flex-col gap-8 lg:gap-16 items-start', imageRight ? 'lg:flex-row' : 'lg:flex-row-reverse')} data-id="element-34">
        {/* Visual Column */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="w-full lg:w-1/2 flex-shrink-0 sticky top-8" data-id="element-35">
          {customVisual ? customVisual : imageSrc ? <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[4/3] lg:aspect-[3/4]" data-id="element-36">
              <img src={imageSrc} alt={imageAlt || headline} className="w-full h-full object-cover" data-id="element-37" />
            </div> : null}
        </motion.div>

        {/* Text Column */}
        <div className="w-full lg:w-1/2 flex flex-col justify-center" data-id="element-38">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-39">
            {headline}
          </h2>
          <div className="text-lg text-slate-800 leading-relaxed space-y-5" data-id="element-40">
            {children}
          </div>
        </div>
      </div>
    </section>;
}